// Settings
import { lazy } from 'react';
import { createRoute } from './utils';
import { Settings } from 'lucide-react';

const SettingsPage = lazy(() => import('@/pages/settings/SettingsPage'));
export const settingsRoutes = [createRoute('settings', <SettingsPage />, 'Settings', Settings)];
